<template>
  <div>
    <div class="header">
      <div :class="{ 'active': limit === 1 }" @click="handleLimitChange(1)">1</div>
      <div :class="{ 'active': limit === 2 }" @click="handleLimitChange(2)">
        <span>1</span>
        <span>2</span>
      </div>
      <div :class="{ 'active': limit === 3 }" @click="handleLimitChange(3)">
        <span>1</span>
        <span>2</span>
        <span>3</span>
      </div>
    </div>
    <div class="material-card">
      <div :class="['main', 'cards-' + limit]" @click="handleCardClick">

        <template v-if="modelValue.cards.length > 0" v-for="item, index in modelValue.cards">
          <div v-if="isVideo(item.url)" @dragstart="onDragstart($event, index)"
            style="display:flex; align-items: center; background-color: #000;" @dragover.prevent="onDragOver(index)"
            @drop="onDrop">
            <VideoPoster :url="item.url" />
          </div>
          <el-image v-else @dragstart="onDragstart($event, index)" @dragover.prevent="onDragOver(index)" @drop="onDrop"
            :src="item.url" fit="cover" />
        </template>

        <div class="add-btn" v-if="!disabled" v-show="modelValue.cards.length <  modelValue.limit" size="30">
          {{ $t('ad.addAsset') }}
        </div>
      </div>

      <div class="foot">
        <span>{{ modelValue.duration }}</span>
        <el-icon size="16" v-if="showEdit" style="margin-left: 10px; cursor: pointer;"
          @click="visible = true; dialogType = 'settime'">
          <Edit color="#999" />
        </el-icon>
        <div v-if="!disabled" style="margin-left: auto; cursor: pointer;">
          <confirm :title="$t('ad.removeScreen')" :message="$t('ad.removeScreenConfirm')" @confirm="handleDeleteScreen">
            <el-icon size="16">
              <Delete color="#f5222d" />
            </el-icon>
          </confirm>
        </div>
      </div>
    </div>
  </div>
  <el-dialog v-model="visible" :title="dialogType === 'settime' ? $t('ad.playTimeDuration') : $t('ad.materialLib')"
    width="600px" :before-close="handleClose">
    <div v-if="dialogType === 'settime'" class="settime">
      <span>{{ $t('ad.picturePlayTime') }}：</span>
      <el-time-picker popper-class="time-overlayer" v-model="duration" format="mm:ss" value-format="mm:ss" />
    </div>
    <div v-else>
      <span>{{ $t('ad.materialNumber') }}</span>
      <span style="display: inline-block ;margin: 0px 20px 10px;">{{ checkList.length }} / {{ limit }}</span>
      <el-checkbox-group class="check-group" v-model="checkList">
        <el-checkbox v-for="  item   in   materialList  " :key="item.id" :label="item" :disabled="item.disabled">
          {{ item.file_name }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click=" visible = false" size="small">{{ $t('ad.cancel') }}</el-button>
        <el-button type="primary" @click="handleDialogConfirm" size="small">
          {{ $t('ad.confirm') }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { getMaterial } from '@/apis/ad'
import { onMounted, ref, watch, defineComponent, computed } from 'vue';
import Confirm from '@/components/confirm/confirm.vue'
import { isVideo, numberToTime } from './utils'
import VideoPoster from './videoPoster.vue'

// modelValue  type { index: 0, cards:[ { id: 1, url:'' } ], duration: 10 }
export default defineComponent({
  name: 'materialCard',
  components: { VideoPoster, Confirm},
  props: {
    modelValue: { type: Object, default: { limit: 1, duration: '00:10' } },
    period: Object,
    disabled: Boolean,
  },
  setup(props, { emit }) {

    const limit = ref(props.modelValue.limit)  // 最大选择的数量
    const dialogType = ref('settime') // settime  or  materialSelect
    const visible = ref(false)
    const duration = ref('00:10')
    const checkList = ref<any[]>([]) // 复选框列表选择的值
    const materialList = ref<any[]>([]) // 复选框列表

    const handleLimitChange = (num: number) => {
      if (props.disabled) return;
      limit.value = num
      const value = { ...props.modelValue }
      if (num > checkList.value.length) {
        materialList.value.forEach(item => item.disabled = false)
      } else {
        while (checkList.value.length - limit.value > 0) {
          checkList.value.pop()
        }
        value.cards = [...checkList.value]
      }
      value.limit = num
      emit('update:modelValue', value)

      // 判断选择列表中是否有视频,只能选择一个视频
      const video = checkList.value.find(item => isVideo(item.file_name))
      if (video) {
        const id = video.id
        materialList.value.forEach(item => {
          if (isVideo(item.file_name) && item.id !== id) {
            item.disabled = true
          }
        })
      }
    }

    const handleCardClick = () => {
      if (props.disabled) return;
      visible.value = true
      dialogType.value = 'materialSelect'
    }

    // 图片拖拽排序
    let fromIndex = 0;
    let targetIndex = 0;

    const onDragstart = (event: any, index: number) => {
      fromIndex = index;
    }
    const onDragOver = (index: number) => {
      targetIndex = index
    }
    const onDrop = () => {
      const value = { ...props.modelValue } as any
      [value.cards[fromIndex], value.cards[targetIndex]] = [value.cards[targetIndex], value.cards[fromIndex]]
      emit('update:modelValue', value)
    }

    const handleClose = () => {
      visible.value = false
    }
    const handleDialogConfirm = () => {
      // 处理时间
      const value = { ...props.modelValue }
      if (dialogType.value === 'settime') {
        value.duration = duration.value
      }
      // 处理素材列表
      if (dialogType.value === 'materialSelect') {
        value.cards = [...checkList.value]
        // 判断是否有选择视频，如果有获取视频的时长
        const video = checkList.value.filter(item => item.type === 'video')
        if (video.length > 0) {
          const audio = new Audio(video[0].url)
          audio.addEventListener("loadedmetadata", (e) => {
            value.duration = numberToTime(Math.floor(audio.duration));
            visible.value = false
            emit('update:modelValue', value)
          });
          // 处理录像无法加载的情况
          audio.addEventListener("error", (e) => {
            value.duration = '00:10'
            visible.value = false
            emit('update:modelValue', value)
          }, false);
          return
        }else{
          if(value.duration === '00:00'){
            value.duration = '00:10'
          }
        }
      }
      visible.value = false
      emit('update:modelValue', value)
    }

    const handleDeleteScreen = () => {
      if (props.period) {
        const index = props.period.material.findIndex((item: any) => item.index === props.modelValue.index)
        props.period.material.splice(index, 1)
      }
    }
    
    const showEdit = computed(()=>{
      if(props.disabled) return false
      if(props.modelValue.cards.length === 0) return false 
      const hasVideo = props.modelValue.cards.find((item:any) => isVideo(item.file_name))
      return hasVideo ? false : true
    })

    watch(() => props.modelValue.cards, (newValue, oldvalue) => {
      if (newValue !== oldvalue) {
        limit.value = props.modelValue.limit
        const result: any[] = []
        props.modelValue.cards.forEach((item: any) => {
          materialList.value.forEach((i: any) => {
            if (item.id === i.id) {
              result.push(i)
            }
          })
        })
        checkList.value = result
      }
    })

    watch(() => checkList.value, (cur, pre) => {
      const length = cur.length
      if (length < limit.value) {
        materialList.value.forEach(item => item.disabled = false)

        // 判断选择列表中是否有视频,只能选择一个视频
        const video = cur.find(item => isVideo(item.file_name))
        if (video) {
          const id = video.id
          materialList.value.forEach(item => {
            if (isVideo(item.file_name) && item.id !== id) {
              item.disabled = true
            }
          })
        }

      } else {
        materialList.value.forEach(item => {
          const index = cur.findIndex(i => i.id === item.id)
          if (index === -1) {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      }
    }, { immediate: true })

    const showCursor = props.disabled ? 'auto' : 'pointer'

    onMounted(() => {
      if (props.disabled) return;
      getMaterial({ limit: false, type: 1 }).then((res: any) => {
        if (res.code === 200) {
          materialList.value = res.data.list || []
        }
      })
    })
    return {
      limit,
      dialogType,
      visible,
      duration,
      checkList,
      materialList,
      handleLimitChange,
      handleCardClick,
      onDragstart,
      onDragOver,
      onDrop,
      handleClose,
      handleDialogConfirm,
      handleDeleteScreen,
      isVideo,
      showEdit,
      showCursor
    }
  }
})


</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-around;

  >div {
    width: 40px;
    height: 60px;
    border: 1px solid #eee;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border-radius: 10px;
    cursor: v-bind(showCursor);
  }

  >div:nth-child(2)>span:nth-child(2) {
    width: 22px;
    text-align: center;
    line-height: 34px;
    border-top: 1px solid #eee;
  }

  >div:nth-child(3)>span:not(:last-child) {
    width: 22px;
    text-align: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 1px;
  }

  margin-bottom: 10px;
}

.active {
  background: #409eff;
  color: #fff;

}

.material-card {
  position: relative;
  width: 196px;
  height: 385px;
  border: 1px #999 dashed;

  .main {
    width: 194px;
    height: 349px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .cards-1,
  .cards-2,
  .cards-3 {
    position: relative;
    flex-direction: column;
    justify-content: flex-start;

    video {
      width: 100%;
    }
    .add-btn{
      position: absolute;
      cursor: pointer;
      background-color: rgba(30,128,255, 0.3);
      width:100%;
      height: 40px !important;
      text-align: center;
      line-height: 40px;
      bottom: 0px;
      color: #fff;
      font-size: 14px;
    }
  }

  .cards-1 {
    div:nth-child(1) {
      height: 100%;
      width: 100%;
    }
  }

  .cards-2 {
    div:nth-child(1) {
      height: 115px;
      width: 100%;
    }

    div:nth-child(2) {
      height: 234px;
      width: 100%;
    }
  }

  .cards-3 {
    div:nth-child(1) {
      height: 116px;
      width: 100%;
    }

    div:nth-child(2) {
      height: 116px;
      width: 100%;
    }

    div:nth-child(3) {
      height: 117px;
      width: 100%;
    }
  }



  .foot {
    position: absolute;
    border-top: 1px dashed #999;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 36px;
    padding: 0 10px;
  }
}

.check-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 10px 20px;
  gap: 10px;
}

:global(.time-overlayer .el-time-spinner.has-seconds) {
  transform: translateX(-56px);
  overflow: hidden;
}
</style>